import '@fontsource-variable/inter'
import { render } from 'preact'
import { registerSW } from 'virtual:pwa-register'
import App from './App'
import { AuthGate } from './auth/AuthGate'
import { watchInstall } from './lib/install'
import { reconcilePushSubscription } from './lib/push'
import './styles.css'

registerSW({ immediate: true })

// Before the first render, and that is the whole reason it is here rather than
// in the component that draws the button: Chrome fires `beforeinstallprompt`
// early, often before Preact has mounted anything, and an event nobody called
// `preventDefault()` on is gone for the session — see src/lib/install.ts.
watchInstall()

// Repair a push subscription the browser rotated behind our back. Fire and
// forget: it must never delay the first paint, and there is nothing for the
// user to do about a failure — the next start tries again. That is why this one
// stays on the console rather than going to the sync badge.
reconcilePushSubscription().catch((error) => {
  console.error('push reconciliation', error)
})

render(
  <AuthGate>
    <App />
  </AuthGate>,
  document.getElementById('app')!,
)
